import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import { EnbekStatus } from "@/types/enbek/Enbek";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  props: {
    status: null
  },
  setup(__props: any) {

const props = __props as { status: EnbekStatus }


const label = computed(() => t(`enbek.status.${props.status.toLowerCase()}`));
const color = computed(
  () =>
    ({
      DRAFT: "bg-gray-100 text-gray-700",
      SENDING: "bg-blue-100 text-blue-700",
      SENT: "bg-blue-100 text-blue-700",
      REGISTERED: "tag--success",
      REJECTED: "tag--error",
      TECHNICAL_ERROR: "bg-amber-100 text-amber-800",
    }[props.status])
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass([
      _unref(color),
      __props.status === 'REGISTERED' || __props.status === 'REJECTED'
        ? 'tag'
        : 'inline-flex rounded-full px-3 py-1 text-xs font-semibold',
    ])
  }, _toDisplayString(_unref(label)), 3))
}
}

})